import React, { useEffect, useState } from 'react';
import { Modal } from 'reactstrap';
import { useSwipeable } from 'react-swipeable';
import useMediaQuery from '../utils/hooks/mediaQuery.hook';
import { ISwipeModal } from './interfaces/ISwipeModal';

const SwipeModal = ({
  isOpen, toggle, className, closeModal, children,
} : ISwipeModal) => {
  const { isMobile } = useMediaQuery();
  const [isSwiped, setIsSwiped] = useState(true);
  const [transformY, setTransformY] = useState(0);
  const [swipeBreakpoint, setSwipeBreakpoint] = useState(0);
  const handlers = useSwipeable({
    onSwipeStart: ({ event: { currentTarget } }) => {
      const targetHeight = (currentTarget as HTMLDivElement).offsetHeight;

      setSwipeBreakpoint(targetHeight / 2);
      setIsSwiped(false);
    },
    onSwiping: ({ deltaY }) => {
      if (deltaY > 0) {
        setTransformY(deltaY);
      }
    },
    onSwipedDown: ({ deltaY, event: { currentTarget } }) => {
      const targetHeight = (currentTarget as HTMLDivElement).offsetHeight;

      if (deltaY > swipeBreakpoint) {
        setTransformY(targetHeight);
      } else {
        setTransformY(0);
      }

      setIsSwiped(true);
    },
  });

  // Bug in reactstrap: open-modal is added to body, but this doesn't do anything.
  // Related issue: https://github.com/reactstrap/reactstrap/issues/2411
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const { ref = undefined, onMouseDown = undefined } = isMobile ? {
    ref: handlers.ref,
    onMouseDown: handlers.onMouseDown,
  } : {};
  const modalTransform = { transform: `translate(0, ${transformY}px)` };
  const modalTransition = {
    baseClass: 'fade fade-in',
    timeout: 500,
  };

  const onTransitionEnd = () => {
    if (transformY > swipeBreakpoint && isSwiped) {
      setSwipeBreakpoint(0);
      closeModal();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className={className}
      style={modalTransform}
      onTransitionEnd={onTransitionEnd}
      modalTransition={modalTransition}
    >
      <div ref={ref} onMouseDown={onMouseDown} role="none">
        {children}
      </div>
    </Modal>
  );
};

export default SwipeModal;
